<template>
  <div>
    <span class="detail-item-label">Voting situation :</span>
    <div>
      <el-progress
        class="common-progress"
        :percentage="percentage"
        :show-text="false"
      ></el-progress>
    </div>
    <div class="spaceBetween">  
      <span class="text-num">
        <span class="text-num-desc">Cumulative</span>
        <div class="text-bold">
          <big-number :number="cumulative" />
          <span>UNIT</span>
        </div>
      </span>
      <span class="text-num text-right">
        <span class="text-num-desc">Threshold</span>
        <div class="text-bold">
          <big-number :number="threshold" />
          <span>UNIT</span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import { toSmallNum } from "@/utils/bigNumberTran.js"
export default {
  props:{
    cumulative:{
      type:[String,Number],
      default:()=> {
        return 0
      }
    },
    threshold:{
      type:[String,Number],
      default:()=> {
        return 100
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    percentage(){
      if(this.threshold){
        let a = toSmallNum(this.cumulative) || 0;
        let b = toSmallNum(this.threshold) || 0;
        if(b && a){
          if(a > b){
            return 100;
          }
          return ((a / b) * 100);
        }
      }

      return 0;
    }
  },
  methods: {

  },
  created() {
  },
  mounted() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.common-progress {
  margin-top: 0.18rem;
  margin-bottom: 0.18rem;
  ::v-deep  .el-progress-bar__inner {
    background: linear-gradient(267deg, #45d1ff 0%, #3172fd 100%);
  }
  ::v-deep  .el-progress-bar__outer {
    height: 0.24rem !important;
    background: rgba(49, 114, 253, 0.2);
  }
}
.text-num .text-bold{
  font-size: 0.18rem;
  line-height: 0.21rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: bold;
  color: #4C4C4C;
  margin-top: 0.06rem;
}
.text-num-desc {
  font-size: 0.16rem;
  font-weight: normal;
  color: #aaaaaa;
  margin-bottom: 0.08rem;
}
</style>
